import { render } from "./ChangeReferent.vue?vue&type=template&id=7f66e9c3"
import script from "./ChangeReferent.vue?vue&type=script&lang=js"
export * from "./ChangeReferent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/referents/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__